module.exports = __webpack_public_path__ + "img/2940373.e999879f.png";